import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

// const headers = {
//   Accept: "application/vnd.api+json",
//   "Content-Type": "application/vnd.api+json",
// };
const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

async function login(user) {
  const response = await axios.post(
    API_URL + "/login",
    {
      user_name: user.username,
      password: btoa(user.password),
      auth_type: "f426c83974ca9778011beac069d26673"
    },
    { headers }
  );

  if (response.data.token) {
    localStorage.setItem("access_token", response.data.token);
  } else {
    this.$store.state.errorLogin = response.data.message;
  }

  //return error.response.data.errors = response.data.errors.email;
  return response.data;
}

async function logout() {
  try {
    await axios.post(API_URL + "/logout", {}, { headers: authHeader() });
    localStorage.removeItem("access_token");
  } finally {
    localStorage.removeItem("access_token");
  }
}

async function register(user) {

  const response = await axios.post(API_URL + '/register',
    {
      name: user.name,
      email: user.email,
      password: user.password,
      password_confirmation: user.confirm_password,
    }, { headers });

  if (response.data.access_token) {
    localStorage.setItem('access_token', response.data.access_token);
  }
  return response.data;
}

async function forgotPassword(data) {
  const response = await axios.post(API_URL + '/password-forgot',
    {
      email: data.email,
      redirect_url: data.redirect_url
    }, { headers });

  return response.data;
}

async function resetPassword(data) {
  const response = await axios.post(API_URL + '/password-reset',
    {
      password: data.password,
      password_confirmation: data.password_confirmation,
      email: data.email,
      token: data.token
    }, { headers });

  return response.data;
}

export default {
  login,
  logout,
  register,
  forgotPassword,
  resetPassword
};